import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//列表
export async function getKhlistWithNoRights(params) {
    return post(erpserver+'/currency/getKhlistWithNoRights', params, true);
}
//公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
//汇率
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}
//银行帐号
export async function getAccountByGsid(params) {
    return post(oaserver+'/payment/excel/getAccountByGsid', params, true);
}
//币种
export async function getBzByBankAccount(params) {
    return post(oaserver+'/payment/excel/getBzByBankAccount', params, true);
}
//baocun
export async function savePayment(params) {
    return post(oaserver+'/payment/excel/savePayment', params, true);
}
//gengxin
export async function updateHistoryPayment(params) {
    return post(oaserver+'/payment/excel/updateHistoryPayment', params, true);
}
//列表
export async function getHistoryPayment(params) {
    return post(oaserver+'/payment/excel/getHistoryPayment', params, true);
}
//yu e
export async function getAmountForDivide(params) {
    return post(oaserver+'/payment/excel/getAmountForDivide', params, true);
}
//fukuanshenqingliebiao
export async function getPaymentApplies(params) {
    return post(oaserver+'/payment/excel/getPaymentApplies', params, true);
}
//guazhangjin e
export async function getPendingAmounts(params) {
    return post(oaserver+'/payment/excel/getPendingAmounts', params, true);
}
//baocun hexiao
export async function manaulProcessHx(params) {
    return post(oaserver+'/payment/excel/manaulProcessHx', params, true);
}
//银行流水冲抵
export async function cancelBillDetail(params) {
    return post(oaserver+'/payment/excel/cancelBillDetail', params, true);
}